/**
 * FeaturedTileCarousel - carousel of featured promo tiles.
 * Custom element: <featured-tile-carousel>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import { biggerPicture } from "./vendor.js";
class FeaturedTileCarousel extends ThemeComponent {
  init() {
    this.setupLightbox();
  }
  setupLightbox() {
    let lightbox = biggerPicture({
        target: document.body
      }),
      videoLinks = this.querySelectorAll("a.featured-tile__video-link");
    for (let videoLink of videoLinks) videoLink.addEventListener("click", openGallery);
    function openGallery(clickEvent) {
      clickEvent.preventDefault(), lightbox.open({
        items: videoLinks,
        el: clickEvent.currentTarget,
        intro: "fadeup"
      });
    }
    setFunctionName(openGallery, "openGallery");
  }
}
setFunctionName(FeaturedTileCarousel, "FeaturedTileCarousel");
const propertyTypes = {};
FeaturedTileCarousel.prototype.$name = "FeaturedTileCarousel";
FeaturedTileCarousel.prototype.$info = JSON.parse('{"name":"FeaturedTileCarousel","meta":{"isLegacy":false,"selector":"featured-tile-carousel"},"props":[],"refs":[]}');
FeaturedTileCarousel.prototype.$info.component = FeaturedTileCarousel;
for (const prop of FeaturedTileCarousel.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("FeaturedTile/FeaturedTileCarousel.ts", {
  FeaturedTileCarousel: FeaturedTileCarousel
}, void 0);